'use strict';

const angular = require('angular');

import { IPayment, IBasket } from '../../interfaces';

export class AdminBasketDeleteComponent{
  $http: ng.IHttpService;

  basket: IBasket;
  payment: IPayment;

  isPayment: boolean = false;

  /*ngInjector*/
  constructor($http)
  {
    this.$http = $http;
  }

  $onInit() {
    let resolve = (this as any).resolve;

    if (_.has(resolve, 'basket') && resolve.basket !== null) {
      this.basket = resolve.basket;

      if (_.has(resolve, 'payment') && resolve.payment !== null) {
        // Edit an existing payment
        this.payment = resolve.payment;
        this.isPayment = true;
      }
    }
  }

  ok() {
    if (this.isPayment) {
      (this as any).close({$value: this.payment});
    } else {
      (this as any).close({$value: this.basket});
    }
  };

  cancel() {
    (this as any).dismiss({$value: 'cancel'});
  };
}


export default angular.module('terrappApp.adminBaskets')
  .component('adminBasketDelete', {
    template: require('./adminBasketDelete.html'),
    controller: AdminBasketDeleteComponent,
    controllerAs: '$ctrl',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
  }).name;


// WEBPACK FOOTER //
// ./client/app/admin/adminBaskets/adminBasketDelete.component.ts